export const categories = {
  informatique: {
    name: 'Informatique et Électronique',
    subcategories: [
      { id: 'reseaux', name: 'Équipements Réseaux' },
      { id: 'impression', name: 'Imprimantes' },
      { id: 'tablettes', name: 'Tablettes' },
      { id: 'impression_3d', name: 'Imprimantes 3D' },
      { id: 'drones', name: 'Drones Professionnels' },
      { id: 'audiovisuel', name: 'Équipements Audiovisuels' },
    ],
  },
  bureautique: {
    name: 'Bureautique',
    subcategories: [
      { id: 'mobilier', name: 'Mobilier de Bureau' },
      { id: 'retroprojecteurs', name: 'Rétroprojecteurs' },
    ],
  },
  vehicules: {
    name: 'Véhicules et Transport',
    subcategories: [
      { id: 'vehicules_utilitaires', name: 'Véhicules Utilitaires' },
      { id: 'motos', name: 'Motos' },
      { id: 'engins_chantier', name: 'Engins de Chantier' },
      { id: 'transport_en_commun', name: 'Transport en Commun' },
      { id: 'vehicules_speciaux', name: 'Véhicules Spéciaux' },
      { id: 'bateaux', name: 'Bateaux' },
    ],
  },
  machines_industrielles: {
    name: 'Machines Industrielles',
    subcategories: [
      { id: 'machines_outils', name: 'Machines-Outils' },
      { id: 'machines_agricoles', name: 'Machines Agricoles' },
      { id: 'equipement_chantier', name: 'Équipement de Chantier' },
      { id: 'machines_production', name: 'Machines de Production' },
      { id: 'machines_textile', name: 'Machines Textiles' },
      { id: 'machines_metallurgie', name: 'Machines de Métallurgie' },
      { id: 'machines_alimentaires', name: 'Machines Alimentaires' },
    ],
  },
  equipements_professionnels: {
    name: 'Équipements Professionnels',
    subcategories: [
      { id: 'outillage', name: 'Outillage Professionnel' },
      { id: 'equipements_metiers', name: 'Équipements Spécifiques' },
      { id: 'materiel_restauration', name: 'Matériel de Restauration' },
      { id: 'equipements_coiffure', name: 'Équipements de Coiffure' },
      { id: 'equipements_sante', name: 'Équipements Médicaux' },
      { id: 'equipements_stockage', name: 'Équipements de Stockage' },
    ],
  },
  agriculture: {
    name: 'Agriculture et Élevage',
    subcategories: [
      { id: 'machines_agricoles', name: 'Machines Agricoles' },
      { id: 'equipements_elevage', name: 'Équipements d\'Élevage' },
      { id: 'stockage_agricole', name: 'Stockage Agricole' },
    ],
  },
  energie: {
    name: 'Énergie et Eau',
    subcategories: [
      { id: 'groupes_electrogenes', name: 'Groupes Électrogènes' },
      { id: 'pompes_eau', name: 'Pompes à Eau' },
      { id: 'traitement_eau', name: 'Traitement d\'Eau' },
      { id: 'reservoirs', name: 'Réservoirs et Stockage' },
    ],
  },
  evenementiel: {
    name: 'Événementiel',
    subcategories: [
      { id: 'tentes', name: 'Tentes et Structures' },
      { id: 'sonorisation', name: 'Sonorisation' },
      { id: 'materiel_livraison', name: 'Matériel de Livraison' },
    ],
  },
};